/**
 * 畅销排行
 */
import axios from "../../utils/axios";

// 类目筛选项
export function getBestsellerRankAsinCategoryMessage(data) {
    return axios({
        url: "/admin/extra/bestseller_rank_asins/get_bestseller_rank_asin_category_message",
        method: "post",
        data
    });
}

// 列表
export function getBestsellerRankAsinsList(data) {
    return axios({
        url: "/admin/extra/bestseller_rank_asins/lists",
        method: "post",
        data
    });
}

